import { render, staticRenderFns } from "./ConfirmDeleteChannel.vue?vue&type=template&id=148b4d61&"
import script from "./ConfirmDeleteChannel.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports